export const AVAILABLE_ROLES = [
  "reader",
  "author", 
  "admin"
  // "super-admin"
]

export const VALID_UPLOAD_FILE_TYPES = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "pdf"
]

export const VALID_UPLOAD_IMAGE_TYPES = [
  "jpg",
  "jpeg",
  "png",
  "gif"
]

export const VALID_MAXIMUM_UPLOAD_SIZE        = 10000000 // 10MB
export const VALID_MAXIMUM_UPLOAD_SIZE_SMALL  = 1000000 // 1MB